import { All, HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface, HeadlineCardInterface } from '../../types/global';
import { adaptBackendFilters } from '../../utils/filters';
import customIcons from '../../utils/icons';
import { HeadlineCard, SnapshotWardRequest } from '../../api-models';

export default class PostHeadlineCardData extends BaseAdapter<HeadlineCard[]> implements AdapterInterface {
  rawResponse: HeadlineCard[];

  modifiedRequest: SnapshotWardRequest;

  async adaptResponse(request: { snapshot: string, liftDataId: string, wardName: string }): Promise<HeadlineCardInterface[]> {
    await this.fetchApiResponse('/api/card/headline/list', HTTPMethod.Post, this.adaptRequest(request));
    return this.rawResponse.map((item) => ({
      title: item.title,
      icon: item.icon.length > 0 ? customIcons[item.icon as keyof typeof customIcons] : undefined,
      value: item.value,
      variance: item.variance,
      trend: item.trend,
      filters: adaptBackendFilters(item.filters),
      description: item.description,
      descriptionFilters: adaptBackendFilters(item.description_filters),
    }));
  }

  adaptRequest(request: { snapshot: string, liftDataId: string, wardName: string }): SnapshotWardRequest {
    const liftDataId = request.liftDataId === String(All.value) ? null : Number(request.liftDataId);
    this.modifiedRequest = {
      snapshot: request.snapshot,
      lift_data_id: liftDataId,
      ward_name: request.wardName,
    };

    return this.modifiedRequest;
  }
}
